import { useState, useEffect } from "react";
import { isAuthenticated, clearAuth } from "../lib/tokenStore";
import { fetchWorkoutPrograms } from "../services/WorkoutEndUserService";
import OtpLogin from "./OtpLogin";
import ProgramJourneyAuth from "./ProgramJourneyAuth";
import { FONT, C } from "../lib/programConstants";

/**
 * Wrapper for /workout route.
 * App launch flow:
 * 1. Check if accessToken exists
 * 2. If YES → try /end-user/workout-programs (V2 multi-program)
 *    - 200: show program selector / journey
 *    - 401: refresh handled by authHttp interceptor, if fails → OTP login
 * 3. If NO → show OTP login
 */
export default function WorkoutAuth() {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);
  const [programs, setPrograms] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    if (!isAuthenticated()) {
      setChecking(false);
      return;
    }

    try {
      const response = await fetchWorkoutPrograms();
      const data = response.data || response;
      setPrograms(Array.isArray(data) ? data : []);
      setAuthed(true);
    } catch (err) {
      clearAuth();
      setAuthed(false);
    } finally {
      setChecking(false);
    }
  };

  const handleLoginSuccess = async () => {
    try {
      setChecking(true);
      const response = await fetchWorkoutPrograms();
      const data = response.data || response;
      setPrograms(Array.isArray(data) ? data : []);
      setAuthed(true);
    } catch (err) {
      setPrograms([]);
      setAuthed(true);
    } finally {
      setChecking(false);
    }
  };

  if (checking) {
    return (
      <div style={{ minHeight: "100vh", background: "#f5f5f5", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: FONT }}>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={{ width: 40, height: 40, border: "3px solid #e0e0e0", borderTopColor: "#111", borderRadius: "50%", animation: "spin 0.8s linear infinite", marginBottom: 16 }} />
        <div style={{ fontSize: 14, color: "#888" }}>Checking your session...</div>
      </div>
    );
  }

  if (!authed) {
    return <OtpLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return <ProgramJourneyAuth programs={programs} />;
}
